import { Component, OnInit, Input } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'prcins-forgot-email-form',
  templateUrl: './forgot-email-form.component.html',
  styleUrls: ['./forgot-email-form.component.css']
})
export class ForgotEmailFormComponent implements OnInit {
  @Input() userForm;

  constructor() { }

  ngOnInit() {
    this.onPolicyTypeSelected();
  }

  onPolicyTypeSelected() {
    if (this.userForm.get('type').value === 'INDIVIDUAL') {
      this.userForm.get('policyNumber').disable();
      this.userForm.get('companyName').disable();
    } else {
      this.userForm.get('policyNumber').enable();
      this.userForm.get('companyName').enable();
    }

    if (this.userForm.get('type').value === 'COMMERCIAL') {
      this.userForm.get('firstName').disable();
      this.userForm.get('lastName').disable();
      this.userForm.get('dob').disable();
    } else {
      this.userForm.get('firstName').enable();
      this.userForm.get('lastName').enable();
      this.userForm.get('dob').enable();
    }
  }

}
